import { apiClient } from '../apiClient';

export interface SiteSessionResponse {
  message: string;
  data: {
    session: boolean;
    authenticated: boolean;
  };
}

export interface SiteAuthLinkResponse {
  message: string;
  data: {
    code: string;
    url: string;
    expires_at: string;
  };
}

export interface SiteAuthStatusResponse {
  message: string;
  data: {
    authenticated: boolean;
    status: 'pending' | 'confirmed';
  };
}

export const loginUser = async (): Promise<SiteSessionResponse> => {
  const response = await apiClient.post<SiteSessionResponse>('/site/login');
  return response.data;
};

export const createTelegramAuthLink =
  async (): Promise<SiteAuthLinkResponse> => {
    const response = await apiClient.post<SiteAuthLinkResponse>('/site/auth-link');
    return response.data;
  };

export const getTelegramAuthStatus = async (
  code: string,
): Promise<SiteAuthStatusResponse> => {
  const response = await apiClient.get<SiteAuthStatusResponse>(
    '/site/auth-status',
    { params: { code } },
  );
  return response.data;
};

export function checkWriteAccessOnLoad(): Promise<boolean> {
  const tg = window?.Telegram?.WebApp;

  if (!tg || typeof tg.requestWriteAccess !== 'function') {
    return Promise.resolve(true);
  }

  return new Promise<boolean>((resolve) => {
    const allows = tg?.initDataUnsafe?.user?.allows_write_to_pm;

    if (allows === true) {
      resolve(true);
      return;
    }

    const requestAccess = () => {
      tg.requestWriteAccess((granted: boolean) => {
        if (granted === false) {
          requestAccess();
        } else {
          resolve(granted);
        }
      });
    };

    requestAccess();
  });
}
